import Lang from '/@/modules/core/app/services/Lang';

export class ClaraForPlannersSeededQuestion {
  static getQuestions(): string[] {
    return [
      Lang.t('ai.clara-for-planners.seeded-question-plan-includes'),
      Lang.t('ai.clara-for-planners.seeded-question-edit-will'),
      Lang.t('ai.clara-for-planners.seeded-question-executor-difference')
    ];
  }
}
